export default {
  chartsData: [],
  loadingCharts: false,
  loadingChartsFailed: false,
  loadingChartsSucceeded: false,
  loadingChartsError: null,

  spotChartsData: [],
  loadingSpotCharts: false,
  loadingSpotChartsFailed: false,
  loadingSpotChartsSucceeded: false,
  loadingSpotChartsError: null,

  surveys: [],
  loadingSurveys: false,
  loadingSurveysFailed: false,
  loadingSurveysError: null,

  periods: [],
  loadingPeriods: false,
  loadingPeriodsFailed: false,
  loadingPeriodsError: null,

  answerGroups: [],
  loadingAnswerGroups: false,
  loadingAnswerGroupsFailed: false,
  loadingAnswerGroupsError: null,

  creatingSpot: false,
  creatingSpotFailed: false,
  creatingSpotSucceeded: false,
  creatingSpotError: null,

  demographics: [],
  loadingDemographics: false,
  loadingDemographicsFailed: false,
  loadingDemographicsSucceeded: false,
  loadingDemographicsError: null,

  respondents: [],
  respondentCount: 1,
  respondentPageInfo: {
    pageNumber: 0,
    pageSize: 0,
    totalEntries: 0,
    totalPages: 0,
  },
  respondentMoreUrl: null,
  loadingRespondents: false,
  loadingRespondentsFailed: false,
  loadingRespondentsSucceeded: false,
  loadingRespondentsError: null,

  downloadResponsesUrl: null,
  downloadingResponses: false,
  downloadingResponsesFailed: false,
  downloadingResponsesSucceeded: false,
  downloadingResponsesError: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/survey/state.js